
import React from 'react';

const UniversalFormWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div>{children}</div>;
};

export default UniversalFormWrapper;
